// extracted by mini-css-extract-plugin
export default {"container":"Bjerr4rbspgQJYHHBSOG"};